import { Box, BoxProps, ColorOptions, Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { StackActions, useNavigation } from '@react-navigation/core'
import { Screens } from '../../nav/Screens'

export const MoreAEPSServices = (params: any) => {
  const screenName = params?.type === 'cash_deposit' ? 'cash_withdrawal' : params?.type

  const navigation = useNavigation()
  if (!(screenName === 'cash_withdrawal' || screenName === 'fund_transfer' || screenName === 'balance_enquiry')) {
    return <></>
  }

  const getData = () => DATA.filter((item: any) => item?.params?.type !== screenName)

  return (
    <Box width={'100%'} mt={32}>
      <Box flexDirection={'row'} justifyContent="center" alignItems={'center'}>
        <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} f={1} mr={20} />
        <Text {...styles.heading}>More AePS Services</Text>
        <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} f={1} ml={20} />
      </Box>
      <Box flexDirection={'row'}>
        {DATA.map((item) => {
          return <MoreServicesItemItem data={item} navigation={navigation} params={params} />
        })}
      </Box>
    </Box>
  )
}

const MoreServicesItemItem = ({ data, navigation, params }: any) => {
  return (
    <Box
      {...styles.moreServicesItemContainer}
      onPress={() =>
        navigation.dispatch(StackActions.replace(data.navigate as never, { ...params, ...data.params } as never))
      }>
      <Box {...styles.iconContainer}>
        <Icon id={data.icon} size={28} color="PRIMARY_STORNG" />
      </Box>
      <Spacer size={8} />
      <Text {...styles.heading} color="PRIMARY_STORNG">
        {data.screenName}
      </Text>
    </Box>
  )
}

const styles = {
  heading: {
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: 'GRAY_75' as ColorOptions,
  } as TextProps,
  iconContainer: {
    p: 10,
    borderRadius: 24,
    size: 48,
    backgroundColor: 'PRIMARY_ULTRA_LIGHT' as ColorOptions,
  } as BoxProps,
  moreServicesItemContainer: {
    flexDirection: 'column',
    f: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
}

const DATA = [
  {
    screenName: 'Cash Withdrawal',
    icon: 'CASH_WITHDRAWL',
    navigate: Screens.CASH_W_OR_D_Screen,
    params: { type: 'cash_withdrawal' },
  },
  /*{
    screenName: 'Fund Transfer',
    icon: 'FUND_TRANSFER',
    navigate: Screens.FUND_TRANSFER,
    params: { type: 'fund_transfer' },
  },*/
  {
    screenName: 'Balance Enquiry',
    icon: 'BALANCE_ENQUIRY',
    navigate: Screens.BALANCE_ENQUIRY,
    params: { type: 'balance_enquiry' },
  },

  {
    screenName: 'Mini Statement',
    icon: 'MINI_STATEMENT',
    navigate: Screens.MINI_STATEMENT,
  },
]
